import { MissingAgreementDataTableDocument } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

export const incompleteContractsData = () => {
  return {
    query: MissingAgreementDataTableDocument,
    projections: [
      {
        path: 'fullName',
        title: i18n.t('finance.financial_workspace.missing_data.export.full_name'),
      },
      {
        path: 'startsOn',
        title: i18n.t('finance.financial_workspace.missing_data.export.starts_on'),
      },
      {
        path: 'effectiveOn',
        title: i18n.t('finance.financial_workspace.missing_data.export.effective_on'),
      },
      {
        path: 'endsOn',
        title: i18n.t('finance.financial_workspace.missing_data.export.ends_on'),
      },
    ],
  }
}
